import {Injectable} from '@angular/core';
// State
import {Store} from '@ngxs/store';

@Injectable({
	providedIn: 'root'
})
export class PermissionService {
	private permission = [];

	constructor(private store: Store) {
		this.store.select(s => s.user.permission).subscribe((permission: any) => {
			this.permission = permission;
		});
	}

	/**
	 * Validate if the Permission exist on the list
	 * @param value
	 */
	public hasPermission(value: any): boolean {
		return this.permission && this.permission.length > 0 && this.permission.includes(value);
	}
}
